import AirCallDialer from './airCallDialer.view';

export default AirCallDialer;
